'use strict';

var emailValidation = {};

exports.__exports = emailValidation;
//# sourceMappingURL=emailValidation.cjs.map
